/**
 * Converts a title string into a URL-friendly slug.
 * Removes Romanian diacritics (ă, â, î, ș, ț), lowercases,
 * replaces non-alphanumeric chars with hyphens, and truncates.
 *
 * @param {string} text - The title to slugify
 * @param {number} maxLength - Maximum slug length (default 80)
 * @returns {string} URL-safe slug
 */
export const slugify = (text, maxLength = 80) => {
  if (!text) return 'detalii';

  let slug = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // strip combining diacritical marks
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumeric → hyphen
    .replace(/-+/g, '-')         // collapse consecutive hyphens
    .replace(/^-|-$/g, '');      // trim leading/trailing hyphens

  // Truncate on word boundary
  if (slug.length > maxLength) {
    slug = slug.substring(0, maxLength);
    const lastHyphen = slug.lastIndexOf('-');
    if (lastHyphen > maxLength * 0.6) {
      slug = slug.substring(0, lastHyphen);
    }
  }

  return slug || 'detalii';
};
